import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useAuthStore } from '@/store/auth';



export default /*#__PURE__*/_defineComponent({
  __name: 'SpinnerDialog',
  setup(__props) {

const auth = useAuthStore();


return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    showHeader: false,
    modal: true,
    visible: _unref(auth).isSpinnerShow,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(auth).isSpinnerShow) = $event)),
    class: "p-dialog-spinner",
    contentClass: "p-dialog-spinner-content"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ProgressSpinner)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})